<div id="map-container" style="width: 100%; height: 500px; min-height: 400px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08);"></div>

<!-- <div class="loader-container" *ngIf="tripsloading">
    <div class="circle-dot-loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div> -->
